import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ArticleDetail from "@/pages/detail/page";
import TopicPage from "@/pages/topic/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:type",
        element: <CategoryPage />,
      },
      {
        path: "detail/:id",
        element: <ArticleDetail />,
      },
      {
        path: "topic/:topicId",
        element: <TopicPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;